export class Walker {
    async goTo(path) {
        window.location.href = path;
    }
}
